.dragHandleCell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.grabCursor {
  cursor: grab;
}
